export type ParticipantNameParts = {
  firstName?: string | null;
  lastName?: string | null;
  preferredName?: string | null;
};

const FormatDisplayName = (
  firstName: string,
  lastName: string,
  preferredName?: string | null,
): string => {
  const given = formatParticipantGivenName(firstName, preferredName);
  const last = lastName ?? "";
  if (given.length > 0 && last.length > 0) {
    return `${last}, ${given}`;
  } else if (given.length > 0) {
    return given;
  } else if (last.length > 0) {
    return last;
  }

  return "Unknown";
};

/** Legal first name, with preferred in parentheses when it differs. */
const formatParticipantGivenName = (
  firstName?: string | null,
  preferredName?: string | null,
): string => {
  const first = (firstName ?? "").trim();
  const preferred = (preferredName ?? "").trim();
  if (preferred && first && preferred.toLowerCase() !== first.toLowerCase()) {
    return `${first} (${preferred})`;
  }
  return first || preferred;
};

/** ``Last, First (Preferred)`` when preferred differs from first; else ``Last, First``. */
const formatParticipantDisplayName = (
  person: ParticipantNameParts | null | undefined,
): string => {
  if (!person) return "Unknown";
  return FormatDisplayName(
    person.firstName ?? "",
    person.lastName ?? "",
    person.preferredName,
  );
};


//  Converts a string to Title Case "SANTA ANA" → "Santa Ana" 
const ToTitleCase = (value: string): string =>
  (value ?? "")
    .toLowerCase()
    .replace(/(^|[\s\-/])(\p{L})/gu, (_, sep, ch) => sep + ch.toUpperCase());

export {
  FormatDisplayName,
  ToTitleCase,
  formatParticipantDisplayName,
  formatParticipantGivenName,
};
